import type { Schemas } from "#shopware";
import { ref, computed } from "vue";
import { createSharedComposable } from "@vueuse/core"; 

const _useProductDetails = () => {
  const reviews = ref<Schemas["ProductReview"][]>([]); // Private reviews state
  const youtubeUrl = ref<string>(""); // YouTube URL as a string
  const manufacturer = ref<Schemas["ProductManufacturer"][]>([]); // Manufacturer as an array
  const productVideos = ref<string[]>([]);

  const setProductVideos = (videos: string[]) => {
    productVideos.value = videos;
  };

  const setReviews = (newReviews: Schemas["ProductReview"][]) => {
    reviews.value = newReviews;
  };

  const setYoutubeUrl = (url: string) => {
    youtubeUrl.value = url;
  };

  const setManufacturer = (newManufacturer: Schemas["ProductManufacturer"][]) => {
    manufacturer.value = newManufacturer;
  };

  const reviewCount = computed(() => reviews.value.length);

  return {
    reviews,
    reviewCount,
    setReviews,
    youtubeUrl,
    setYoutubeUrl,
    manufacturer,
    setManufacturer,
    productVideos,
    setProductVideos
  };
};

// Create a shared instance
export const useProductDetails = createSharedComposable(_useProductDetails);
